export const defaultEmojiMeetingType = '1f4c5'; //📅
